import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {APP_MESSAGES} from "../../enums/enums";
import {ModalService} from "../../services/modal.service";
import {DocumentService} from "../../services/document.service";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {Subject} from "rxjs/Subject";

declare var $:any;

@Component({
  selector: 'nv-message-modal',
  templateUrl: './nv-message-modal.component.html',
  styles: []
})
export class NvMessageModalComponent implements OnInit {

  onDeleteMessage = "";
  private unsubscribe: Subject<void> = new Subject<void>();
  @ViewChild("messageModal") messageModal:ElementRef;

  constructor(private modalService: ModalService,
              private documentService:DocumentService) { }

  ngOnInit() {
    this.modalService
      .onModalRequest
      .filter(
        appMessage => appMessage.type === APP_MESSAGES.POPUP_MESSAGE)
      .subscribe(
        appMessage => this.confirm(appMessage.content));
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private confirm(onDeleteMessage:string){
    console.log('message');
    this.onDeleteMessage = onDeleteMessage;
    $(this.messageModal.nativeElement).modal("show");
  }
 }



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-message-modal/nv-message-modal.component.ts